import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import '../../pages/Capacitaciones.css';
import './ModalCrearUsuario.css';

const LABELS = {
  informe: 'Informe',
  planilla: 'Planilla',
  rh: 'RH',
  certificado: 'Certificado',
};

function ModalCesoArchivo({ isOpen, onClose, onSave, row, campo }) {
  const [archivo, setArchivo] = useState(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setArchivo(null);
    if (fileRef.current) fileRef.current.value = '';
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!archivo) return alert('Seleccione un archivo PDF.');
    await onSave({ id_cese: row.id_cese, campo, archivo });
    onClose(true);
  };

  const titulo = campo ? LABELS[campo] || 'Documento' : 'Documento';

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>ADJUNTAR {titulo.toUpperCase()}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>Colaborador</Label>
              <Input type="text" value={row?.nombre_usuario || ''} disabled />
            </FormGroup>

            <FormGroup>
              <Label>Archivo (PDF)</Label>
              <div className="cap-upload-zone">
                <span className="cap-upload-btn" onClick={() => fileRef.current?.click()}>
                  {archivo ? archivo.name : 'Seleccionar PDF'}
                </span>
                <input
                  ref={fileRef}
                  type="file"
                  accept=".pdf"
                  style={{ display: 'none' }}
                  onChange={(e) => setArchivo(e.target.files?.[0] || null)}
                />
              </div>
              <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>
                {archivo ? (
                  <span
                    style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                    onClick={() => {
                      setArchivo(null);
                      if (fileRef.current) fileRef.current.value = '';
                    }}
                  >
                    ✕ Quitar
                  </span>
                ) : (
                  'Ningún archivo'
                )}
              </div>
            </FormGroup>

            <div className="button-container" style={{ marginTop: 14 }}>
              <Button className="button-custom" color="secondary" onClick={() => onClose(false)}>
                CANCELAR
              </Button>
              <Button className="button-custom" onClick={handleSubmit}>
                GUARDAR
              </Button>
            </div>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalCesoArchivo;
